module.exports = __webpack_public_path__ + "static/media/KOL2-NEW.bd02c481.apng";